const module = { name: 'movie/shared/mobile/carousel', exports: {} }; const exports = module.exports;



import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as link } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { default as movie_shared_iconicImgUI_updateIconicImg } from 'swug-fdRequire-call:movie/shared/iconicImgUI';

const { updateIconicImg } = movie_shared_iconicImgUI_updateIconicImg;


const Selectors = Object.freeze({
    GALLERY: '#movie-detail-dropdown-media-gallery',
    PHOTOS_SECTION: '#movie-details-photos-container',
    IMG_BTN: '.js-gallery-img-btn',
})


const Styles = Object.freeze({
    LANDSCAPE: 'carousel__img--landscape',
    HIDE: 'hide',
    CAROUSEL_OPEN: 'carousel--open',
})


let $carousel


let carouselData
function setImageOrientation(images) {
    const isLandscape = window.innerHeight < window.innerWidth;
    $.each(images, (index, image) => $(image).toggleClass(Styles.LANDSCAPE, isLandscape));
}
function updateIndex() {
    if (carouselData.selectedIndex === undefined) {
        return;
    }
    const currentCellIndex = carouselData.selectedIndex + 1;
    $('.js-index-current').text(currentCellIndex);
    $('#open-all-carousel').attr('data-image-index', currentCellIndex);
}
function onOpenClick(e) {
    e.preventDefault();
    const galleryImages = $('.js-carousel__img');
    const cellIndex = parseInt($(this)[0].dataset.imageIndex) - 1;
    $('.js-carousel-main').addClass(Styles.CAROUSEL_OPEN);
    $carousel.flickity('select', cellIndex);
    updateIndex();
    setImageOrientation(galleryImages);
    $(window).resize(() => setImageOrientation(galleryImages));
    track({
        event: EventTypes.PHOTO_CLICKS
    });
}
function onCloseClick(e) {
    e.preventDefault();
    $('.js-carousel-main').removeClass(Styles.CAROUSEL_OPEN);
}
function onStaticClick() {
    const $elems = $('#carousel-header, .js-flickity-btns, .js-cell-text');
    const headerIsVisible = $('#carousel-header').is(':visible');
    $elems.toggleClass(Styles.HIDE, headerIsVisible);
}
function onDrag() {
    $('.js-flickity-btns').addClass(Styles.HIDE);
}
function onSlideSettle() {
    updateIndex();
}
function initEventHandlers() {
    $(Selectors.IMG_BTN).on('click', onOpenClick);
    $('#close-carousel').on('click', onCloseClick);
    $carousel.on('staticClick.flickity', onStaticClick);
    $carousel.on('settle.flickity', onSlideSettle);
    $carousel.on('dragMove.flickity', onDrag);
}
function onFetchDone(cellTemplate, cb, data) {
    const imgCellsMarkup = swig.render(cellTemplate, data);
    const carouselMarkup = swig.render('_carousel', data);
    const markup = imgCellsMarkup + carouselMarkup;
    const $imgGallery = $(Selectors.GALLERY);
    if (!markup || !data || !data.images || !data.images.length) {
        document.querySelector(Selectors.PHOTOS_SECTION)?.classList.add(Styles.HIDE);
        return cb(false);
    }
    $imgGallery.html(markup);
    updateIconicImg(data, 300);
    $carousel = $('.js-carousel-flickity')
        .flickity({
        cellAlign: 'left',
        contain: true,
        setGallerySize: false,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: false
    });
    carouselData = $carousel.data && $carousel.data('flickity') || {};
    if (carouselData.cells) {
        $('.js-index-total').text(carouselData.cells.length);
    }
    $carousel.find('.flickity-prev-next-button').addClass('js-flickity-btns');
    initEventHandlers();
    cb(true);
}
function onFetchFail(cb, data) {
    debugLog.error(`${module.name} fetch failed`, data);
    document.querySelector(Selectors.PHOTOS_SECTION)?.classList.add(Styles.HIDE);
    cb(false);
}
function attach(opts, cb) {
    cb = noop(cb);
    opts = opts || {};
    const { id, cellTemplate } = opts;
    xhr.ajax({
        method: 'GET',
        url: link.napiMovieCarousel({ id }),
    })
        .done(onFetchDone.bind(this, cellTemplate, cb))
        .fail(onFetchFail.bind(this, cb));
}
module.exports = {
    attach,
};
export default module.exports;